import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppBasicsService, ObjectState } from '@meddev/fe-shared';
import { BaseInitAppService } from '@shared/core';
import { AuthAppService } from '@shared/data';
import { map, Observable } from 'rxjs';

@Component({
    selector: 'mca-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterOutlet, AsyncPipe],
})
export class AppComponent implements OnInit {
    private readonly authAppService = inject(AuthAppService);
    private readonly appBasicsService = inject(AppBasicsService);
    private readonly appInitManagerService = inject(BaseInitAppService);
    private readonly appPwaSettings$ = this.appInitManagerService.appPwaSettings$;

    public title = $localize`:@@Angular Application title:MCA`;
    public isInitializing$ = this.isInitializing();

    ngOnInit(): void {
        this.authAppService.initAfterAppInitializer()?.subscribe();

        this.appPwaSettings$.subscribe(settings => {
            if (settings?.settings?.bsId) {
                this.appBasicsService.setBusinessSubject({
                    id: settings.settings.bsId,
                });
            }
        });

        this.authAppService.getUserInfo().subscribe(userInfo => {
            if (userInfo) {
                this.appBasicsService.setUser({
                    id: userInfo.id,
                    name: userInfo.firstName,
                    surname: userInfo.lastName,
                    email: userInfo.email || '',
                });
            }
        });
    }

    private isInitializing(): Observable<boolean> {
        return this.authAppService.authState$.pipe(
            map(authInfo => {
                const isInitializing = authInfo.state === ObjectState.UNINIT;
                return isInitializing;
            }),
        );
    }
}
